export const IPERF_CAP_SCOPE_STORAGE_KEY = 'nm.iperfCapScope';

export function extractCapSerialsFromSelection(selectedDevices, isCapDevice) {
  const caps = new Set();
  (selectedDevices || []).forEach((device) => {
    if (!device?.serial_number) return;
    if (isCapDevice(device)) {
      caps.add(device.serial_number);
    }
    const capSerial = String(device?.cap_serial || '').trim();
    if (capSerial) caps.add(capSerial);
  });
  return [...caps];
}

/** Selected node serials (excludes CAP devices) for focused iperf under map selection. */
export function extractFocusSerialsFromSelection(selectedDevices, isCapDevice) {
  return (selectedDevices || [])
    .filter((device) => device?.serial_number && !isCapDevice(device))
    .map((device) => device.serial_number);
}

export function persistIperfCapScope({ capSerials, focusSerials } = {}) {
  if (!capSerials?.length) return;
  sessionStorage.setItem(
    IPERF_CAP_SCOPE_STORAGE_KEY,
    JSON.stringify({
      capSerials,
      focusSerials: Array.isArray(focusSerials) ? focusSerials.filter(Boolean) : [],
    }),
  );
}

export function consumeIperfCapScope() {
  try {
    const raw = sessionStorage.getItem(IPERF_CAP_SCOPE_STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(IPERF_CAP_SCOPE_STORAGE_KEY);
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.capSerials) || parsed.capSerials.length === 0) {
      return null;
    }
    return parsed;
  } catch {
    sessionStorage.removeItem(IPERF_CAP_SCOPE_STORAGE_KEY);
    return null;
  }
}
